
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouter2 as ObiRouter2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-router-2.js';
 
 
 

 
 export const ObiRouter2 = createComponent({
   react: React,
   tagName: 'obi-router-2',
   elementClass: ObiRouter2Element,
   events: {
     
   }
  });
 
 